import { Box, Grid, Paper, Snackbar, Table, TableBody, TableContainer, TableHead, TablePagination, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { debounce } from 'lodash';
import styles from '../../../styles.module.css';
import { useDispatch, useSelector } from "react-redux";
import { ActionMsg, AddButton, Breadcrumb, CustomePopover, DateConversionOnEntryPage, DeleteDialog, ExcelDownload, HandleCloseSnackbar, HandleSort, SearchInput, StyledTableCell, StyledTableRow, useMessageHandler } from "../../reusableComponent/Reusables";
import { editDeleteBom, getBomList } from "../../../actions/actions";
import HeaderSection from "../../reusableComponent/HeaderSection";
import bomService from "../../../services/utility/bom.Service";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";

const BomList = () => {
    const dispatch = useDispatch();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;

    const [isDelete, setIsDelete] = useState(false);
    const [deleteInfo, setDeleteInfo] = useState();
    const [sortBy, setSortBy] = useState(null);
    const totalCount = useSelector(state => state.bom.total_count || 0);
    const defaultRowsPerPage = useSelector(state => state.bom.rows_per_page || 15);
    // const rows = useSelector(state => state.bom.bom || []);
    const[rows, setRows] = useState([]);
    const [searchKey, setSearchKey] = useState('');

    const fields = ['id', "dress_type", "cost"];
    const labels = ['Id', "dress_type", "cost"];

    const [successMessage, setSuccessMessage] = useState(null);
    const respMsgState = useSelector((state) => state.bom.message);
  const [total_count,setTotalCount]=useState(null)
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);
    const [controller, setController] = useState({
        page: 0,
        rowsPerPage: defaultRowsPerPage
    });

    useEffect(() => {
        setController(prev => ({
            ...prev,
            rowsPerPage: defaultRowsPerPage,
            page: 0,
        }));
    }, [defaultRowsPerPage]);

    const handleChangePage = (event, newPage) => {
        setController({
            ...controller,
            page: newPage
        });
    };

    const handleChangeRowsPerPage = (event) => {
        setController({
            ...controller,
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        });
    };


   const fetchData = async () => {
           try {
             const params = {
               page: controller.page,
               size: controller.rowsPerPage,
               searchKey: searchKey,
             };
             const response = await bomService.getBomList (params);
             setRows(response);
           } catch (error) {
             setSuccessMessage("Error fetching data");
           }
         };

    // Search by Product Code with debouncing
    // Ensure backend API supports prod_code as a query parameter for partial matches
    const handleSearch = debounce((value) => {
        console.log('Search value:', value); // Debug search value
        setSearchKey(value);
        setController(prev => ({ ...prev, page: 0 })); // Reset to first page on search
        const params = {
            page: 0,
            size: controller.rowsPerPage,
            prod_code: value || undefined, // Search by Product Code
        };
        console.log('Searching with params:', params); // Debug search params
        dispatch(getBomList(params));
    }, 300);

    const onSearchChange = (e) => {
        console.log('Search event:', e); // Debug event object
        if (e && e.target && typeof e.target.value !== 'undefined') {
            handleSearch(e.target.value);
        } else {
            console.error('Invalid search event:', e);
            setSuccessMessage('Error: Invalid search input');
        }
    };

    useEffect(() => {
        fetchData();
    }, [controller]);

    // useEffect(() => {
    //     console.log('Rows:', rows); // Debug rows
    //     console.log('Total Count:', totalCount); // Debug totalCount
    //     console.log('Response Message:', respMsgState); // Debug respMsgState
    // }, [rows, totalCount, respMsgState]);

    // const { shouldShowMsg, responseMessage } = useMessageHandler(fetchData, null, setSuccessMessage, respMsgState);
    // useEffect(() => {
    //     if (respMsgState) {
    //         setSuccessMessage(respMsgState);
    //     }
    // }, [respMsgState]);

     const deleteRecord = async (id) => {
            try {
              await bomService.editDeleteBom ({
                bom_id: id,
                changedUpdatedValue: "delete"
              });
              setIsDelete(false);
              fetchData();
              setSuccessMessage("Record deleted successfully");
            } catch (error) {
              setSuccessMessage("Error deleting record");
            }
          };

    const handleDelete = (functions) => {
        setIsDelete(true);
        setDeleteInfo(functions);
    };

    const handleClose = (event, reason) => {
        setIsDelete(false);
        setDeleteInfo(null);
    };

    // Sort rows by entry_date descending
    const sortedRows = [...rows].sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));
    // Calculate pagination info
  const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;


    console.log('Pagination Info:', { startRecord, endRecord, totalCount, effectiveTotalCount, paginationInfo });

    return (
        <Box className={`${styles.cts_page}`} sx={{ padding: "0px !important", margin: "0px !important" }}>
            <Box className={`${styles.body}`}>
                <Breadcrumb
                    routeSegments={[
                        { name: 'Bom List' },
                    ]}
                />

                <HeaderSection
                    title="Bom List"
                    addNewPath="/utility/add-bom"
                    searchKey={searchKey}
                    handleSearch={onSearchChange}
                    sortedRows={sortedRows}
                    fields={fields}
                    labels={labels}
                    filename="Bom List"
                    paginationInfo={paginationInfo}
                    controller={controller}
                    handleChangePage={handleChangePage}
                />

                <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
                    <Table size="small" stickyHeader>
                        <TableHead>
                            <StyledTableRow>
                                <StyledTableCell sx={{ width: '20%' }} align="left" className={`${styles.table_head}`} onClick={() => HandleSort('prod_code', sortBy, setSortBy, rows)}>Product Code<span className={`${styles.sort_icon}`}> {sortBy === 'prod_code' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell sx={{ width: '20%' }} align="right" className={`${styles.table_head}`} onClick={() => HandleSort('qty', sortBy, setSortBy, rows)}>Quantity<span className={`${styles.sort_icon}`}> {sortBy === 'qty' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="center" className={`${styles.table_head}`}>Action</StyledTableCell>
                            </StyledTableRow>
                        </TableHead>
                        <TableBody sx={{ backgroundColor: '#fff' }}>
                            {Array.isArray(rows) && rows.length > 0 ? (
                                rows.map((row, index) => (
                                    <StyledTableRow
                                        key={row.name || index} // Fallback to index if row.name is undefined
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                       
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                                            {row.prod_code || ''}
                                        </StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.list_table_body}`}>
                                            {row.qty || ''}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            <CustomePopover row={row} handleDelete={false} linkTo="/utility/add-bom" />
                                        </StyledTableCell>
                                    </StyledTableRow>
                                ))
                            ) : (
                                <StyledTableRow>
                                    <StyledTableCell colSpan={3} align="center">
                                        No data available
                                    </StyledTableCell>
                                </StyledTableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
               
                <DeleteDialog
                    open={isDelete}
                    handleClose={handleClose}
                    deleteInfo={deleteInfo}
                    deleteRecord={deleteRecord}
                    deleteID={deleteInfo?.bom_id || null}
                    displayName={deleteInfo?.bom_id || ''}
                />
                <ReusableSnackbar
                    open={!!successMessage}
                    onClose={(event, reason) => {
                        if (reason !== 'clickaway') {
                            setSuccessMessage("");
                        }
                    }}
                    message={successMessage}
                    autoHideDuration={2000}
                    vertical="top"
                    horizontal="right"
                />
            </Box>
        </Box>
    );
};

export default BomList;